import OQCalcApi from "@/api/OQCalcApi";
import OQModXSiteApi from "@/api/OQModXSiteApi";

const OQClientApi = {
  setProductNameOrder: (order_id, product_name) => {
    window.localStorage.setItem(`U|ORDERS|${product_name}`, order_id);
  },
  getProductNameOrder: (product_name) => {
    return window.localStorage.getItem(`U|ORDERS|${product_name}`);
  },
  clearProductNameOrder: (product_name) => {
    return window.localStorage.removeItem(`U|ORDERS|${product_name}`);
  },
  makeCartItem: async (order, cart_item_id = undefined) => {
    const cart_item = await OQCalcApi.getCartItem(order);
    if (cart_item_id) {
      // update local cart item
      OQModXSiteApi.update_cart_item(cart_item_id, cart_item);
    } else {
      // create new cart_item and add it to cart
      cart_item_id = OQModXSiteApi.add_cart_item(cart_item);
    }
    return cart_item_id;
  },
  clearOrderOptions: () => {
    window.localStorage.removeItem("O|DOO");
  },
  getOrderOptions: () => {
    return JSON.parse(window.localStorage.getItem(`O|DOO`));
  },
  setOrderOptions: (options) => {
    window.localStorage.setItem("O|DOO", JSON.stringify(options));
  },
  redirectToOrder: (cart_item_id, order_options) => {
    window.location.href =
      order_options?.order_url + "cartItemId=" + cart_item_id;
  },
  getOrderOptionsByCartId: (cartItemId) => {
    return JSON.parse(window.localStorage.getItem(`O|OO|${cartItemId}`));
  },
  setOrderOptionsByCartId: (cartItemId, options) => {
    window.localStorage.setItem(
      `O|OO|${cartItemId}`,
      JSON.stringify(options || {})
    );
  },
};

export default OQClientApi;
